import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGlobe,
  faBuilding,
  faShoppingCart,
  faRobot,
} from '@fortawesome/free-solid-svg-icons';
import './style.css';

const services = [
  {
    icon: faGlobe,
    title: "Landing Pages",
    description: "Single pages that convert visitors into customers"
  },
  {
    icon: faBuilding,
    title: "Corporate Sites",
    description: "Professional websites that showcase your expertise"
  },
  {
    icon: faShoppingCart,
    title: "E-Commerce",
    description: "Complete online store solutions that sell 24/7"
  },
  {
    icon: faRobot,
    title: "AI & Automation Integrations",
    description: "Advanced integrations tailored to your business needs"
  },
];

export default function ServicesOverviewSection({ id }) {
  return (
    <section id={id || "services-overview"} className="services-overview-section">
      <Container>
        <div className="text-center mb-4">
          <h2 className="services-title">
            What Kind of Website Do You Need?
          </h2>
          <div className="services-lead">
            We build websites for every type of business
          </div>
        </div>
        <Row className="justify-content-center text-center mb-4">
          {services.map((service, i) => (
            <Col xs="12" sm="6" md="3" key={i} className="mb-4">
              <div className="services-overview-item">
                <FontAwesomeIcon
                  icon={service.icon}
                  size="2x"
                  className="services-overview-icon"
                />
                <div className="services-overview-label">
                  {service.title}
                </div>
                <div className="services-overview-desc">
                  {service.description}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
